// oxlint-disable-next-line no-restricted-imports
import { fromJS, Map, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import type { VariationSummary } from '#utils/flags/records/VariationSummary';
import { createVariationSummary } from '#utils/flags/records/VariationSummary';

type TargetingSummaryProps = {
  prerequisites: number;
  variations: Map<number, VariationSummary>;
};

export class TargetingSummary extends Record<TargetingSummaryProps>({
  prerequisites: 0,
  variations: Map(),
}) {}

export function createTargetingSummary(props?: CreateFunctionInput<TargetingSummary>) {
  const summary = props instanceof TargetingSummary ? props : new TargetingSummary(fromJS(props));
  return summary.withMutations((s) => {
    s.update('variations', (vs) => (vs ? vs.map(createVariationSummary) : Map()));
  });
}
